module.exports = __webpack_public_path__ + "img/ico-settings.da86cf7c.svg";